<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
      <app-breadcrumb class="col-12" [breadcrumb]="breadcrumb"></app-breadcrumb>
    </div>
    <div class="content-body">
      <!-- <ngx-spinner bdColor="rgba(0,0,0,0.5)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
        <p style="color: white"> Loading... </p>
      </ngx-spinner> -->
      <app-custom-loader-c></app-custom-loader-c>

      <section id="base-style">
        <div class="row">

          <div class="col-12" *blockUI="'baseStyle'; message: 'Loading'">
            <m-card [options]="options" (reloadFunction)="reloadBaseStyle($event)">
              <ng-container mCardBody>



                <div class="card-dashboard">
                  <div class="row">
                    <div class="col-sm-12 col-md-12">
                      <div class="dataTables_filter">
                        <span class="pull-right">
                          <h5><input type='text'
                              style='padding:4px;margin:0px auto; margin-left:8px; width:200px;border-radius: .22rem; border: 1px solid #BABFC7;'
                              placeholder='Search' (keyup)='updateFilter($event)' />

                            <button (click)="GetExcelRentBillsData()" class="btn btn-primary btn-sm gap_contact"
                              style="MARGIN-LEFT: 5PX;margin-top: -2px;">
                              <i class="d-md-none d-block feather ft-plus white"></i><span
                                class="d-md-block d-none">Export To
                                Excel</span></button>
                          </h5>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="table table-striped table-bordered base-style">
                    <ngx-datatable class="bootstrap ps" [limit]="10" [rows]="rows" [columnMode]="'force'"
                      [headerHeight]="50" [footerHeight]="50" [rowHeight]="50" fxFlex="auto" [perfectScrollbar]="config"
                      [rowHeight]="'auto'">
                      <ngx-datatable-footer>
                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
                          let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset"
                          let-isVisible="isVisible">
                          <div class="page-count">
                            Showing {{(offset * pageSize)+1}} to {{(rowCount>
                            (curPage*pageSize))?(curPage*pageSize):(rowCount)}} of
                            {{(rowCount)}} records.
                          </div>
                          <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'"
                            [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'"
                            [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize"
                            [count]="rowCount" [hidden]="!((rowCount / pageSize) > 1)"
                            (change)="table.onFooterPage($event)">
                          </datatable-pager>
                        </ng-template>
                      </ngx-datatable-footer>

                      <ngx-datatable-column name="Bill No" [flexGrow]="1" [minWidth]="15" prop="displayBillNumber">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          {{row.displayBillNumber}}
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="Type" [flexGrow]="1" [minWidth]="180" prop="billType">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          {{row.billType}} {{ row.isIgstBill ? " - IGST" : ""}}

                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="Name" [flexGrow]="1" [minWidth]="90" prop="customerFullName">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          <div class="datatablecustomerow firstletteruppercase" title="{{row.customerFullName}}">
                            {{row.customerFullName}}
                          </div>


                        </ng-template>
                      </ngx-datatable-column>


                      <ngx-datatable-column name="Total" [flexGrow]="1" [minWidth]="90" prop="totalAmountIncGST">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          {{row.totalAmountIncGST}}
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="Paid" [flexGrow]="1" [minWidth]="90" prop="totalpaidAmount">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          {{row.totalpaidAmount}}
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="Balance Amount" [flexGrow]="1" [minWidth]="180" prop="balanceAmount">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          <span style="color: red;" *ngIf="row.balanceAmount!=0"> {{row.balanceAmount}}</span>
                          <span style="color: rgb(7, 228, 7);" *ngIf="row.balanceAmount==0">
                            {{row.balanceAmount}}</span>
                        </ng-template>
                      </ngx-datatable-column>

                      <ngx-datatable-column name="Deposit" [flexGrow]="1" [minWidth]="180" prop="rentBillDeposit">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          <span class="success bold"> {{row.rentBillDeposit}}</span>
                        </ng-template>
                      </ngx-datatable-column>

                      <ngx-datatable-column name="Contact No" [flexGrow]="1" [minWidth]="90" prop="customerContact">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          {{row.customerContact}}
                        </ng-template>
                      </ngx-datatable-column>
                      <ngx-datatable-column name="Bill Date" [flexGrow]="1" [minWidth]="90" prop="billDate">
                        <ng-template ngx-datatable-cell-template let-row="row">
                          {{this.dateconfig.getshortdate(row.billDate)}}
                        </ng-template>
                      </ngx-datatable-column>




                      <ngx-datatable-column name="Actions" [flexGrow]="1" [minWidth]="90">
                        <ng-template ngx-datatable-cell-template let-row="row">

                          <!-- <a [routerLink]="['/bill/addbill']" *ngIf="UserTypeDescription=='Admin'" [queryParams]="{Id:encrypt(row.idBillmaster)}"
                          class="primary edit mr-1 mrless">
                              <i class="la la-pencil" title="Edit Bill "></i></a> -->
                          <a [routerLink]="['/rentinvoice/add']" [queryParams]="{Id:encrypt(row.idBillmaster)}"
                            class="primary edit mr-1 mrless">
                            <i class="la la-pencil" title="Edit Bill "></i></a>
                          <a class="danger delete mr-1 mrless" *ngIf="UserTypeDescription=='Admin'"><i
                              class="la la-trash-o" title="Delete" (click)="showConfirm(row.idBillmaster)"></i></a>

                          <a [routerLink]="['/viewrentbill']" target="_blank"
                            [queryParams]="{Id:encrypt(row.idBillmaster)}" class="primary edit mr-1 mrless">
                            <i class="feather ft-printer" title="View "></i>
                          </a>
                        </ng-template> -->
                      </ngx-datatable-column>

                    </ngx-datatable>
                  </div>
                </div>
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>